'use client';

import { createUseClientTranslation } from '@tuic/i18n';

export const useClientTranslation = createUseClientTranslation({
  translationResourceLoader: (locale, namespace) => {
    return import(`./../../locales/${locale}/${namespace}.json`);
  },
});
